export const RENT_PROFIT = [
  {
    id: 1,
    title: 'Оставьте заявку',
    description: ['Оформить заявку можно онлайн на сайте.', 'Мы расскажем о сервисе и ответим на все вопросы.'],
  },
  {
    id: 2,
    title: 'Подключим к сервису',
    description: [
      'Поможем создать и загрузить всё необходимое в личный кабинет.',
      'В нём вы будете следить за показами и отчётами, отбирать кандидатов, подписывать документы и проводить платежи.',
    ],
  },
  {
    id: 3,
    title: 'Подготовим квартиру и объявление',
    description: [
      'Проведём встречу, на которой обсудим арендную плату и критерии для жильцов, подпишем документы и возьмём ключи.',
      'Затем подготовим жильё к сдаче: установим технику для дистанционных показов, сделаем профессиональные фотографии и объявление.',
    ],
  },
  {
    id: 4,
    title: 'Подберём арендатора',
    description: [
      'Мы возьмём на себя показы и общение с кандидатами, а отчёты будем загружать в личный кабинет.',
      'Когда найдём потенциальных арендаторов, передадим вам их анкеты с рекомендациями.',
      'Если среди кандидатов вы выберете подходящего,  мы проверим его надёжность и согласуем с вами.',
    ],
  },
  {
    id: 5,
    title: 'Заселим и останемся рядом',
    description: [
      'Мы остаёмся на связи с вами и жильцом на весь срок аренды.',
      'Будем контролировать оплату, решать спорные моменты и отвечать на вопросы.',
      'Если жилец решит съехать, проверим сохранность имущества и найдём нового.',
    ],
  },
];
